<div class="widget-data">
  <div class="container">
    <div class="d-flex">
      <img
        src="assets/images/nafath-verification/nafath-verification.svg"
        alt="Nafath Verification"
        class="nafath-verification"
      />
    </div>

    <h1>{{ "lets-get-Started-with-madfu" | translate }}</h1>
    <p class="nafath-number">{{ random }}</p>

    <p class="verification-steps">
      {{ "verification-steps" | translate }}
    </p>

    <div class="step">
      <img
        src="assets/images/nafath-verification/nafath.svg"
        [alt]="'download-nafath-app' | translate"
        class="nafath-icon"
      />

      <span class="step-text">{{ "download-nafath-app" | translate }}</span>
    </div>

    <div class="vertical-dashes"></div>

    <div class="step">
      <img
        src="assets/images/nafath-verification/chonse-above-number.svg"
        [alt]="'choose-above-number' | translate"
        class="choose-above-number-icon"
      />

      <span class="step-text">{{ "choose-above-number" | translate }}</span>
    </div>

    <button type="button" (click)="verifyNafath()" [disabled]="isLoading">
      {{ "submit" | translate }}
    </button>
  </div>
</div>

<app-nafath-verification-success-popup
  *ngIf="isVerificationSuccess"
></app-nafath-verification-success-popup>
